"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetWalletConnector = exports.catchWalletConnectError = exports.walletConnected = exports.connectWallet = exports.reconnectWallet = void 0;
const walletConnectorSlice_1 = require("./walletConnectorSlice");
const { actions } = walletConnectorSlice_1.walletConnectorSlice;
const reconnectWallet = () => (dispatch) => {
    dispatch(actions.reconnectWallet());
};
exports.reconnectWallet = reconnectWallet;
const connectWallet = () => (dispatch) => {
    dispatch(actions.connectWallet());
};
exports.connectWallet = connectWallet;
const walletConnected = (userAccount) => (dispatch) => {
    dispatch(actions.walletConnected({ userAccount }));
};
exports.walletConnected = walletConnected;
const catchWalletConnectError = () => (dispatch) => {
    dispatch(actions.catchWalletConnectError({ payload: {} }));
};
exports.catchWalletConnectError = catchWalletConnectError;
const resetWalletConnector = () => (dispatch) => {
    dispatch(actions.disconnectWallet({ payload: {} }));
};
exports.resetWalletConnector = resetWalletConnector;
//# sourceMappingURL=walletConnectorActions.js.map